import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Card,
  CardContent,
  LinearProgress,
} from "@mui/material";
import { api_Routes } from "../../../api_Routes";
import { Helper } from "../../../tools/Helper";
import { useNavigate } from "react-router-dom";

const ResellerReviews = () => {
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const getReviews = async () => {
      setIsLoading(true);
      const url = api_Routes.Reseller.GetReviews;
      const { response } = await Helper.Get({
        url: url,
        hasToken: true,
      });
      if (response) {
        setData(response.data);
      }
      setIsLoading(false);
    };
    getReviews();
  }, []);

  const handleRowClick = (resellerid) => {
    navigate(`/resellers/${resellerid}`);
  };
  // Add these functions
  const handleDeleteClick = (e, review) => {
    e.stopPropagation();
    setSelectedReview(review);
    setDeleteConfirmOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (selectedReview) {
      const { response } = await Helper.Get({
        url: `${api_Routes.Reseller.DeleteReview}/${selectedReview.id}`,
        hasToken: true,
      });
      if (response) {
        setData(data.filter((item) => item.id !== selectedReview.id));
      }
      setDeleteConfirmOpen(false);
    }
  };
  return (
    <Box>
      <Typography
        sx={{
          color: "#474747",
          fontWeight: "600",
          fontSize: "24px",
          lineHeight: "30px",
        }}
      >
        Resellers Reviews
      </Typography>
      <Card>
        <CardContent sx={{ background: "#F8FAFF" }}>
          {isLoading && <LinearProgress />}
          {data?.length === 0 ? (
            <Typography sx={{ textAlign: "center" }}>
              There are no Reviews yet
            </Typography>
          ) : (
            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "none",
                borderBottom: "1px solid #00000080",
                marginTop: "20px",
              }}
            >
              <Table>
                <TableHead sx={{ borderBottom: "1px solid #00000080" }}>
                  <TableRow sx={{ backgroundColor: "#D1DDE4" }}>
                    <TableCell
                      align="center"
                      sx={{ fontWeight: "bold", color: "#333333" }}
                    >
                      Date
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontWeight: "bold", color: "#333333" }}
                    >
                      Subject
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontWeight: "bold", color: "#333333" }}
                    >
                      Rating
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontWeight: "bold", color: "#333333" }}
                    >
                      Reseller Name
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bold" }}>
                      Description
                    </TableCell>
                    {/* <TableCell align="center" sx={{ fontWeight: "bold" }}>
                      Verified
                    </TableCell> */}
                    <TableCell
                      align="center"
                      sx={{ fontWeight: "bold", color: "#333333" }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((review) => (
                    <TableRow
                      key={review.id}
                      hover
                      sx={{
                        backgroundColor: "#E5EDFF",
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#D0DDFF !important" },
                      }}
                      onClick={() => handleRowClick(review.reseller?.id)}
                    >
                      <TableCell align="center">
                        {review.formatted_created_at}
                      </TableCell>
                      <TableCell align="center">{review.subject}</TableCell>
                      <TableCell align="center">
                        {Array.from({ length: review.rate }, (_, i) => (
                          <span key={i}>⭐</span>
                        ))}
                      </TableCell>

                      <TableCell align="center">
                        {review.reseller?.name || "N/A"}
                      </TableCell>
                      <TableCell align="center">
                        {review.description || "N/A"}
                      </TableCell>
                      {/* <TableCell align="center">
                        {review.verified ? "Yes" : "No"}
                      </TableCell> */}
                      <TableCell
                        sx={{
                          justifyContent: "space-between",
                        }}
                        align="center"
                      >
                        <Button
                          variant="contained"
                          color="error"
                          sx={{
                            ml: 1,
                            backgroundColor: "red",
                            color: "#fff",
                            boxShadow:
                              "0px 3px 3px #00000040, inset 0px 4px 7px #FFFFFF40",
                            borderRadius: "10px",
                            "&:hover": {
                              backgroundColor: "#2d5aa3",
                            },
                          }}
                          onClick={(e) => handleDeleteClick(e, review)}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </CardContent>
      </Card>
      <Dialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
      >
        <Paper sx={{ p: 3, minWidth: 400 }}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this review?
              <br />
              <strong>This action cannot be undone.</strong>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
            <Button
              variant="outlined"
              onClick={() => setDeleteConfirmOpen(false)}
              sx={{ width: 120 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleDeleteConfirm}
              sx={{ width: 120 }}
            >
              Delete
            </Button>
          </DialogActions>
        </Paper>
      </Dialog>
    </Box>
  );
};

export default ResellerReviews;
